import type { ServiceAuthFactory } from "../../../services/auth/types";
import { MyQueueAuthAdapter, MyQueueTasksAuthAdapter } from "./adapter";

export const myqueueAuthFactory: ServiceAuthFactory = {
  addinKey: "myqueue",
  create(cfg, deps) {
    return new MyQueueAuthAdapter(cfg, deps);
  },
};

export const myqueueTasksAuthFactory: ServiceAuthFactory = {
  addinKey: "myqueue-tasks",
  create(cfg, deps) {
    return new MyQueueTasksAuthAdapter(cfg, deps);
  },
};
